import { Component, computed, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerClock, tablerShieldQuestion } from '@ng-icons/tabler-icons';
import { MatMenuModule } from '@angular/material/menu';

type AssetTrustState =
  | 'governance_only'
  | 'rai_only'
  | 'governance_and_rai'
  | 'verification_in_progress'
  | 'none'
  | 'error';

@Component({
  selector: 'asset-trust-badge',
  templateUrl: './asset-trust-badge.html',
  styleUrl: './asset-trust-badge.scss',
  imports: [NgIcon, MatMenuModule],
  providers: [provideIcons({ tablerClock, tablerShieldQuestion })],
  host: {
    '[class.isAssetCard]': 'isAssetCard()',
  },
})
export class AssetTrustBadge {
  isGovernanceVerified = input.required<boolean>();
  isRaiVerified = input.required<boolean>();
  isVerificationInProgress = input.required<boolean>();
  isAssetCard = input(false);

  /**
   * There are 5 possible legitimate states:
   * - Governance verified ONLY
   * - RAI verified ONLY
   * - Both Governance and RAI verified ONLY
   * - Verification in progress ONLY
   * - None, i.e. all FALSE
   *
   * Any other combination is an error
   */
  assetTrustState = computed<AssetTrustState>(() => {
    if (this.isGovernanceVerified() && !this.isRaiVerified() && !this.isVerificationInProgress()) {
      return 'governance_only';
    }
    if (!this.isGovernanceVerified() && this.isRaiVerified() && !this.isVerificationInProgress()) {
      return 'rai_only';
    }
    if (this.isGovernanceVerified() && this.isRaiVerified() && !this.isVerificationInProgress()) {
      return 'governance_and_rai';
    }
    if (!this.isGovernanceVerified() && !this.isRaiVerified() && this.isVerificationInProgress()) {
      return 'verification_in_progress';
    }
    if (!this.isGovernanceVerified() && !this.isRaiVerified() && !this.isVerificationInProgress()) {
      return 'none';
    }
    return 'error';
  });
}
